import script from "./EditorItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditorItem.vue?vue&type=script&setup=true&lang=ts"

import "./EditorItem.vue?vue&type=style&index=0&id=5e94916b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e94916b"]])

export default __exports__